export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-3">
              关于我们
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              关于天天影院
            </h2>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  天天影院成立于2024年，致力于为追剧爱好者打造一站式的剧集资源整理平台。我们专注整理最新电视剧全集，涵盖<strong>国产剧全集在线</strong>、<strong>韩剧全集免费</strong>、<strong>美剧全集播放</strong>与<strong>日剧全集资源</strong>四大核心品类。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  平台每日同步更新，内容团队第一时间收录最新剧集，确保追剧无需等待。我们坚持免费开放原则，所有剧集资源均可在线观看，无需注册、无需付费、无需下载。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  天天影院持续优化播放体验，提供高清画质与流畅不缓冲的观影环境。目前覆盖12个内容分类，服务数百万追剧用户，是您追剧路上的可靠伙伴。
                </p>
              </div>
              <div className="w-full lg:w-[280px] flex-shrink-0">
                <div className="bg-primary-50 rounded-xl p-6 text-center">
                  <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center bg-primary-500 text-background-50 rounded-2xl text-2xl font-bold">
                    天
                  </div>
                  <p className="font-heading text-lg font-bold text-foreground-950">天天影院</p>
                  <p className="text-xs text-foreground-500 mt-1">追剧无需等待</p>
                  <div className="mt-4 pt-4 border-t border-primary-200/50 space-y-2 text-left">
                    <div className="flex items-center justify-between text-xs text-foreground-600">
                      <span>内容分类</span>
                      <span className="font-semibold text-foreground-900">12 个</span>
                    </div>
                    <div className="flex items-center justify-between text-xs text-foreground-600">
                      <span>日更新量</span>
                      <span className="font-semibold text-foreground-900">50+ 部</span>
                    </div>
                    <div className="flex items-center justify-between text-xs text-foreground-600">
                      <span>运营时间</span>
                      <span className="font-semibold text-foreground-900">全天候</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}